<template>
  <div class="element-check">
    <el-dialog
      :visible.sync="visible"
      @open="open"
      :modal-append-to-body="false"
      top="5vh">
      <h1 slot="title" class="modal-header-title">图片库</h1>
      <el-row :gutter="10">
        <el-col :span="6">
          <div class="element-check-tree">
            <template>
              <el-tree
                ref="tree"
                highlight-current
                :data="treeList"
                :props="treeProps"
                node-key="id"
                default-expand-all
                @node-click="nodeClick"
                :expand-on-click-node="false">
              <span class="custom-tree-node" slot-scope="{node, data}">
                <span>{{ node.label }}</span>
                <span>
                  <el-button
                    type="text"
                    size="mini">
                    {{data.checkedCount ? data.checkedCount : ''}}
                  </el-button>
                </span>
              </span>
              </el-tree>
            </template>
          </div>
        </el-col>
        <el-col :span="18">
          <div class="element-check-content" v-loading="loading">
            <div class="upload-img">
              <el-button @click="clickUploadImg">上传本地图片</el-button>
            </div>
            <element-item :data="imgList" @change-box="onCheckedBox" check-box position :span="6" :gutter="20" bodyClass="height: 180px" :props="opts"></element-item>
            <div class="page">
              <el-pagination
                background
                :current-page="pageNum"
                :page-size="pageSize"
                :total="total"
                small
                @current-change="onCurrentChange"
                layout="total, prev, pager, next">
              </el-pagination>
            </div>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" style="text-align: center">
        <el-button type="primary" @click="onClickConfirm">确定</el-button>
      </div>
    </el-dialog>
    <upload-picture
      :uploaderOptions="options"
      v-model="uploadVisible"
      check-box
      :select="currentNode && currentNode.id ? currentNode.id : ''"
      @all-upload-success="onAllSuccess">
      <div slot="formatDesc">仅支持 gif、 jpeg、 png、 bmp 4种格式</div>
    </upload-picture>
  </div>
</template>

<script>
import ElementItem from '@/components/element/element-item.vue'
import UploadPicture from '@/components/picture-upload/picture-uploader.vue'
// import _ from 'lodash'
export default {
  name: 'elementCheck',
  components: {ElementItem, UploadPicture},
  props: {
    value: {
      type: Boolean,
      default: true
    },
    limit: { // 限制选择个数,0表示不限制
      type: Number,
      default: 0
    },
    defaultCheckedList: {
      type: Array,
      default () {
        return []
      }
    },
    clear: {
      type: Boolean,
      default: false
    },
    props: {
      type: Object,
      default () {
        return {}
      }
    },
    defaultKey: {
      type: String,
      default: 'id'
    },
    isOpenInit: Boolean
  },
  watch: {
    visible (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.visible = val
    },
    props () {
      this.opts = Object.assign({}, this.imgProps, this.props)
    },
    checkedList: {
      deep: true,
      handler () {
        this.setCheckedCount()
      }
    },
    defaultCheckedList: {
      deep: true,
      immediate: true,
      handler () {
        this.setDefaultCheckedList(true)
      }
    }
  },
  data () {
    return {
      visible: false,
      pageNum: 1,
      pageSize: 12,
      loading: false,
      total: 0,
      treeList: [], // 目录列表
      imgList: [], // 图片列表
      treeProps: { // 设置树形显示的别名
        label: 'cataName',
        children: 'childrenList'
      },
      imgProps: { // 图片显示的别名
        name: 'imageName',
        url: 'imageFileUrl'
      },
      opts: {},
      options: {
        multiple: true, // 是否可以多选
        drag: false, // 是否支持拖拽
        autoUpload: false, // 是否自动上传
        accept: 'image/gif,image/jpeg,image/png,image/bmp' // 支持的图片格式
      },
      uploadVisible: false, // 是否显示上传控件
      currentNode: null, // 当前选中节点
      checkedList: [], // 选中的图片数组列表
      isInit: false
    }
  },
  methods: {
    setCheckedCount () {
      if (this.treeList) {
        // 图片只有一个一级分类。。。。
        let childrenList = this.treeList[0].childrenList
        childrenList.forEach(child => {
          this.$set(child, 'checkedCount', this.checkedList.filter(item => item.cid === child.id).length)
        })
      }
    },
    setDefaultCheckedList (reload) {
      if (this.imgList && this.treeList && this.treeList.length) {
        if (reload) this.checkedList = JSON.parse(JSON.stringify(this.defaultCheckedList))
        this.setCheckedCount()
        this.imgList.forEach(img => {
          // 这里直接用了id 后期优化
          let checkedIndex = this.checkedList.findIndex(check => check[this.defaultKey] === img[this.defaultKey])
          // 这里需要设置当前图片列表的选中状态
          this.$set(img, 'check', checkedIndex !== -1)
        })
        // this.isInit = true
      }
    },
    getImgTreeList () { // 获得菜单列表
      this.$api('element/allCatalogList', { // 获得左侧节点列表
        typeId: 1 // 类型ID
      })().then(data => {
        this.treeList = data.list
        data.list[0].childrenList.forEach(item => {
          this.$set(item, 'checkedCount', '')
        })
        if (this.treeList && this.treeList.length > 0) {
          this.$nextTick(() => {
            if (this.$refs.tree) this.$refs.tree.setCurrentKey(data.list[0].childrenList[0].id)
          })
        }
        this.currentNode = data.list[0].childrenList[0]
        this.getImgList()
      }).catch(err => {
        this.$message.error(err.data && err.data.msg ? err.data.msg : err.msg)
      })
    },
    getImgList () { // 获得图片列表
      this.loading = true
      this.$api('element/imgList', {
        imageCataId: this.currentNode.id,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })().then(data => {
        data.page.list.forEach(item => {
          let index = this.checkedList.findIndex(that => item[this.defaultKey] === that[this.defaultKey])
          if (index !== -1) {
            item.check = true
          }
          this.$set(item, this.opts.url, item[this.imgProps.url])
          this.$set(item, this.opts.name, item[this.imgProps.name])
        })
        this.imgList = data.page.list
        this.pageNum = data.page.pageNum
        this.pageSize = data.page.pageSize
        this.total = data.page.total
        // this.setDefaultCheckedList(true)
        this.loading = false
      }).catch(err => {
        this.$message.error(err.data && err.data.msg ? err.data.msg : err.msg)
        this.loading = false
      })
    },
    nodeClick (data, node, that) { // 节点点击事件
      if (node.level === 1) {
        this.$refs.tree.setCurrentKey(this.currentNode.id)
        return
      }
      this.pageNum = 1
      this.currentNode = data
      this.getImgList()
    },
    clickUploadImg () { // 点击上传图片按钮
      if (!this.currentNode) {
        this.currentNode = this.$refs.tree.getCurrentNode()
      }
      this.uploadVisible = true
    },
    onAllSuccess (fileList) { // 上传成功的回调事件
      setTimeout(() => {
        this.getImgList()
      }, 300)
    },
    onCurrentChange (val) { // 当前页码改变事件
      this.pageNum = val
      this.getImgList()
    },
    onCheckedBox (val) {
      if (this.limit <= this.checkedList.length && val.check) {
        val.check = false
        this.$alert('已达到选择上限无法继续选择图片', '警告', {
          type: 'warning'
        })
        return
      }
      if (val.check) {
        this.checkedList.push({
          cid: val.imageCataId, // 分类id
          ...val
        })
      } else {
        let index = this.checkedList.findIndex(item => item[this.defaultKey] === val[this.defaultKey])
        if (index !== -1) {
          this.checkedList.splice(index, 1)
        }
      }
    },
    onClickConfirm () { // 点击确认按钮事件
      this.visible = false
      this.$emit('on-confirm', JSON.parse(JSON.stringify(this.checkedList)))
      if (this.clear) {
        this.imgList.forEach(img => this.$set(img, 'check', false))
        this.checkedList = []
      }
    },
    open () { // 打开窗口触发事件
      // this.getImgTreeList() // 获得树形列表菜单
      if (this.isOpenInit) this.setDefaultCheckedList(true)
    }
  },
  mounted () {
    this.opts = Object.assign({}, this.imgProps, this.props)
    this.getImgTreeList() // 获得树形列表菜单
  }
}
</script>

<style lang="scss">
  @import '../../assets/scss/variable.scss';
  $content_height: 690px;
  .element-check {
    .jc-modal {
      width: 1000px;
    }
    .element-check-tree { // 树形控件样式
      border: 1px solid $default_color;
      height: $content_height;
      padding: 5px;
      .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
      }
    }
    .element-check-content { // 内容展现样式
      padding: 8px;
      border: 1px solid $default_color;
      height: $content_height;
      .upload-img {
        padding: 0 0 10px 0;
        text-align: right;
      }
      .page {
        text-align: right;
        position: relative;
        bottom: 5px;
        right: 0px;
        &:after, &:before {
          clear: both;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/element/index.vue